module.exports = __webpack_public_path__ + "static/media/mc.37be4651.svg";